export const scrollToHash = {
  methods: {
    scrollToHash() {
      this.$nextTick(() => {
        if (this.$route.hash) {
          this.$scrollTo(this.$route.hash, 500, { offset: -64 });
        }
      });
    }
  }
};
